/* ============================================================================
   UMAI guest wishlist (Fashion-Nova style, no backend)
   - localStorage-backed list of product snapshots (works for logged-out guests)
   - wires every [data-wish] heart button on the site (collection cards, PDP,
     You-May-Also-Like), reflects saved state, and keeps the header badge live
   - the wishlist PAGE (sections/umai-wishlist.liquid) renders from the same store
   Public API: window.UmaiWishlist = { read, has, toggle, remove, count }
   ========================================================================== */
(function () {
  'use strict';
  var KEY = 'umaiWishlist';
  var MAX = 40; // FN-style guest cap

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: list.length } }));
  }
  /* `list` is optional: a caller sweeping many hearts reads storage once and
     passes the parsed array in, instead of a JSON.parse per heart (2026-09-07). */
  function has(handle, list) { return (list || read()).some(function (i) { return i.h === handle; }); }
  function count() { return read().length; }
  function remove(handle) { write(read().filter(function (i) { return i.h !== handle; })); }
  function toggle(item) {
    var list = read();
    var idx = -1;
    for (var i = 0; i < list.length; i++) { if (list[i].h === item.h) { idx = i; break; } }
    if (idx >= 0) { list.splice(idx, 1); }
    else { if (list.length >= MAX) list.pop(); list.unshift(item); }
    write(list);
    return idx < 0; // true = added
  }

  window.UmaiWishlist = { read: read, has: has, toggle: toggle, remove: remove, count: count };

  /* ---- heart-button wiring ---- */
  function syncBtn(btn, list) {
    var h = btn.getAttribute('data-wish-handle');
    btn.setAttribute('aria-pressed', has(h, list) ? 'true' : 'false');
  }
  function itemFrom(btn) {
    return {
      h: btn.getAttribute('data-wish-handle'),
      id: btn.getAttribute('data-wish-id') || '',
      t: btn.getAttribute('data-wish-title') || '',
      u: btn.getAttribute('data-wish-url') || '',
      img: btn.getAttribute('data-wish-img') || '',
      p: btn.getAttribute('data-wish-price') || '',
      c: btn.getAttribute('data-wish-compare') || ''
    };
  }
  function wire(btn, list) {
    syncBtn(btn, list);
    /* an ATTRIBUTE, not a JS property, so wireAll can skip wired hearts in the
       selector itself (2026-09-07, Ryan) — see the note on wireAll */
    btn.setAttribute('data-wish-wired', '');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var h = btn.getAttribute('data-wish-handle');
      if (!h) return;
      var added = toggle(itemFrom(btn));
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      /* heart pop on save (not un-save) — .pop rules live in umai-shell.css so
         every heart (PDP / collection / YMAL) animates; reflow retrigger */
      btn.classList.remove('pop');
      if (added) { void btn.offsetWidth; btn.classList.add('pop'); }
    });
  }
  /* Only hearts that are NOT wired yet (2026-09-07, Ryan). The observer below
     watches the whole body, and something mutates the body every second on every
     page — the announcement-bar countdown rewrites its clock text on a 1s
     interval. Every one of those ticks used to re-run wire() over every heart,
     and wire() called syncBtn BEFORE its already-wired early-return, so a
     collection page did 60 JSON.parse(localStorage) per second, forever, for a
     result that had not changed. Wired hearts stay correct without this sweep:
     the wishlist:change and storage listeners below re-sync them. A tick that
     brings no new hearts now costs one selector query and nothing else.
     NOTE: setAttribute is an attribute mutation, and the observer only watches
     childList — marking a heart cannot wake the observer again. */
  function wireAll() {
    var btns = document.querySelectorAll('[data-wish]:not([data-wish-wired])');
    if (!btns.length) return;
    var list = read(); /* one parse for the whole sweep */
    for (var i = 0; i < btns.length; i++) wire(btns[i], list);
  }

  /* ---- header badge ---- */
  var lastCount = null; /* null = first paint, never bump on load */
  function updateBadge() {
    var n = count();
    var grew = lastCount !== null && n > lastCount;
    lastCount = n;
    var badges = document.querySelectorAll('[data-wish-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n;
      if (n === 0) badges[i].setAttribute('hidden', ''); else badges[i].removeAttribute('hidden');
      /* same bump as the cart badge (umai-badge-bump in umai-shell.css) —
         count-up only, reflow-retriggered for rapid saves */
      if (grew) { badges[i].classList.remove('bump'); void badges[i].offsetWidth; badges[i].classList.add('bump'); }
    }
  }

  /* the list really changed — re-sync every heart on the page, wired or not,
     reading storage once for the whole sweep */
  function syncAll() {
    var btns = document.querySelectorAll('[data-wish]');
    var list = read();
    for (var i = 0; i < btns.length; i++) syncBtn(btns[i], list);
    updateBadge();
  }

  document.addEventListener('wishlist:change', syncAll);

  /* cross-tab sync */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    syncAll();
  });

  function init() {
    wireAll();
    updateBadge();
    /* YMAL + collection cards render async — re-wire when new hearts appear */
    if (window.MutationObserver) {
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        /* setTimeout, not rAF: rAF is throttled to zero in background tabs (and
           in headless), which left dynamically-rendered YMAL/"For You" hearts
           unwired. setTimeout still coalesces per macrotask. */
        setTimeout(function () { pending = false; wireAll(); }, 0);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
